import React, { Component, Fragment } from 'react'
import Loader from './Loader'
export default class PrintsLoader extends Component {
  render() {
    return (
      <Fragment>
        <LoadingPrintCard/>
        <LoadingPrintCard/>
      </Fragment>
    )
  }
}

class LoadingPrintCard extends Component {
    render(){
        return(
            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-3">
                {/* card for fees */}
                <div className="card min-h-200">
                    <div className="card-body print-container">
                        <div className="print-session">
                        <Loader
                        width = '100'
                        height = '20'
                        />
                        </div>
                        <h2>
                        <Loader
                        width = '600'
                        height = '70'
                        />
                       </h2>
                        <div className="print-btn-container">
                            <div className="row no-gutters">
                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                    <Loader
                                    width = '600'
                                    height = '70'
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
